import React from "react";
import { Link } from "react-router-dom";

export default function DemoCTA({ variant = "inline", className = "" }) {
    if (variant === "full") {
        return (
            <div className={`bg-white border border-gray-200 rounded-2xl shadow-sm p-8 text-center ${className}`}>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">
                    Ready to Track Your Real Finances?
                </h2>
                <p className="text-gray-700 mb-6 max-w-lg mx-auto">
                    Connect your accounts and see your complete financial picture.
                    Start your 14-day free trial today.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link to="/signup" className="btn-primary px-8 py-3 text-base font-semibold">
                        Start Free Trial
                    </Link>
                    <Link to="/about" className="btn-secondary px-8 py-3 text-base font-semibold">
                        Learn More
                    </Link>
                </div>
                <p className="mt-4 text-gray-500 text-sm">
                    14 days free, then $12/month. Cancel anytime.
                </p>
            </div>
        );
    }

    // Inline variant - smaller, for within tabs
    return (
        <div className={`card p-6 border-accent-200 ${className}`}>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div>
                    <p className="text-gray-900 font-medium">Like what you see?</p>
                    <p className="text-sm text-gray-500">Start tracking your real finances today.</p>
                </div>
                <Link to="/signup" className="btn-primary px-6 py-2.5 whitespace-nowrap">
                    Get Started Free
                </Link>
            </div>
        </div>
    );
}
